import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./thumb.html';
import styles from './thumb-hashed.scss';

/**
 * @ngdoc component
 * @name gw-thumb
 *
 * @description A component used to display a thumb item within a thumblist that can be selected
 *
 */
export default {
    template: cssUtil.hashTemplate(template, styles),
    bindings: {
        selected: '=',
        icon: '@'
    },
    transclude: true
};
